<template>
  <div>
    <div style="display:flex; flex-direction:row; ">
      <a-button class="indexBtn" style="" @click="backIndex()">首页</a-button>
      <a-pagination :current="current" :total="mintotal" @change="onChange" :pageSize="pageSize" />
      <a-button class="nextBtn" @click="next()">下一页</a-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pageSize: {
      type: Number,
      default: 3
    },
    total: {
      type: Number,
      default: 0
    },
    nowCurrent: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      current: 1,
      mintotal: 50,
    };
  },
  mounted() {


  },
  watch: {
    total: {
      handler(total) {
        this.mintotal = total
      },
      deep: true,
      immediate: true
    },
    nowCurrent: {
      handler(nowCurrent) {
        this.current = nowCurrent
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onChange(current) {
      this.current = current;
      this.$emit("getPage", this.current);
    },
    next() {
      this.current = this.current + 1;
      this.$emit("getPage", this.current);
    },
    backIndex() {
      this.current = 1;
      this.$emit("getPage", this.current);
    }
  }
};
</script>
<style scoped>
.indexBtn {
  margin-right: 10px;
  background-color: #005a51;
  color: #fff;
}
.nextBtn {
  margin-left: 10px;
  background-color: #005a51;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/pageFen.vue